export default "__VITE_ASSET__NGuyNCg8__"